import { QueryKey, UseQueryResult } from 'react-query'
import * as Rest from 'src/constants/rest'
import useFetch from 'src/hooks/useFetch'
import {
  Comunidad,
  Pais,
  Provincia,
  Municipio,
  PartidoJudicial,
  OrganoJudicial,
  Colegio,
  Entidad,
  Sexo,
  TipoPersona,
  TipoDocumentoIdentificativo,
  TipologiaProcedimiento,
  TipoIntervencion,
  TipoProcedimiento,
  TipoDocumento,
  TipoRepresentacion,
  TipoVia,
  SubTipoDocumento,
  Materia
} from 'src/interfaces/Catalog'

function useFetchComunidades(key: QueryKey, enabled = true): UseQueryResult<Comunidad[], unknown> {
  return useFetch<Comunidad[]>(key, Rest.COMUNIDADES_LIST, enabled)
}

function useFetchProvincias(key: QueryKey, enabled = true): UseQueryResult<Provincia[], unknown> {
  return useFetch<Provincia[]>(key, Rest.PROVINCIAS_LIST, enabled)
}

function useFetchMaterias(key: QueryKey, enabled = true): UseQueryResult<Materia[], unknown> {
  return useFetch<Materia[]>(key, Rest.MATERIAS_LIST, enabled)
}

function useFetchMunicipios(key: QueryKey, enabled = true): UseQueryResult<Municipio[], unknown> {
  return useFetch<Municipio[]>(key, Rest.MUNICIPIOS_LIST, enabled)
}

function useFetchPartidoJudicial(
  key: QueryKey,
  enabled = true
): UseQueryResult<PartidoJudicial[], unknown> {
  return useFetch<PartidoJudicial[]>(key, Rest.PARTIDOS_JUDICIALES_LIST, enabled)
}

function useFetchOrganoJudicial(
  key: QueryKey,
  enabled = true
): UseQueryResult<OrganoJudicial[], unknown> {
  return useFetch<OrganoJudicial[]>(key, Rest.ORGANOS_JUDICIALES_LIST, enabled)
}

function useFetchColegios(key: QueryKey, enabled = true): UseQueryResult<Colegio[], unknown> {
  return useFetch<Colegio[]>(key, Rest.COLEGIOS_LIST, enabled)
}

function useFetchTipoPersona(
  key: QueryKey,
  enabled = true
): UseQueryResult<TipoPersona[], unknown> {
  return useFetch<TipoPersona[]>(key, Rest.TIPO_PERSONA_LIST, enabled)
}

function useFetchTipoDocumentoIdentificativo(
  key: QueryKey,
  enabled = true
): UseQueryResult<TipoDocumentoIdentificativo[], unknown> {
  return useFetch<TipoDocumentoIdentificativo[]>(key, Rest.TIPO_DOCUMENTO_IDENTIFICATIVO, enabled)
}

function useFetchProcedimientoTipologia(
  key: QueryKey,
  enabled = true
): UseQueryResult<TipologiaProcedimiento[], unknown> {
  return useFetch<TipologiaProcedimiento[]>(key, Rest.TIPOLOGIA_PROCEDIMIENTO, enabled)
}

function useFetchProcedimientoTipo(
  key: QueryKey,
  isAdaptadoTest: boolean,
  enabled = true
): UseQueryResult<TipoProcedimiento[], unknown> {
  const endpoint = isAdaptadoTest
    ? Rest.TIPO_PROCEDIMIENTO_PIEZA // Normativa técnica del CTEAJE (9), usar cuando Adaptado_test en organo judicial = 1
    : Rest.TIPO_PROCEDIMIENTO // Codificación LexNET (4), usar cuando Adaptado_test en  organo judicial = 0
  return useFetch<TipoProcedimiento[]>(key, endpoint, enabled)
}

function useFetchTipoDocumento(
  key: QueryKey,
  enabled = true
): UseQueryResult<TipoDocumento[], unknown> {
  return useFetch<TipoDocumento[]>(key, Rest.TIPO_DOCUMENTO, enabled)
}

function useFetchSubTipoDocumento(
  key: QueryKey,
  enabled = true
): UseQueryResult<SubTipoDocumento[], unknown> {
  return useFetch<SubTipoDocumento[]>(key, Rest.SUB_TIPO_DOCUMENTO, enabled)
}

function useFetchTipoVia(key: QueryKey, enabled = true): UseQueryResult<TipoVia[], unknown> {
  return useFetch<TipoVia[]>(key, Rest.TIPO_VIA, enabled)
}

function useFetchTipoRepresentacion(
  key: QueryKey,
  enabled = true
): UseQueryResult<TipoRepresentacion[], unknown> {
  return useFetch<TipoRepresentacion[]>(key, Rest.TIPO_REPRESENTACION, enabled)
}

function useFetchSexo(key: QueryKey, enabled = true): UseQueryResult<Sexo[], unknown> {
  return useFetch<Sexo[]>(key, Rest.SEXO, enabled)
}

function useFetchPais(key: QueryKey, enabled = true): UseQueryResult<Pais[], unknown> {
  return useFetch<Pais[]>(key, Rest.PAIS, enabled)
}

function useFetchTipoIntervencion(
  key: QueryKey,
  enabled = true
): UseQueryResult<TipoIntervencion[], unknown> {
  return useFetch<TipoIntervencion[]>(key, Rest.TIPO_INTERVENCION, enabled)
}

function useFetchEntidades(key: QueryKey, enabled = true): UseQueryResult<Entidad[], unknown> {
  return useFetch<Entidad[]>(key, Rest.ENTIDAD_LIST, enabled)
}

function useFetchEntidadesByOrganismoOrigen(
  key: QueryKey,
  enabled = true
): UseQueryResult<Pais[], unknown> {
  return useFetch<Pais[]>(key, Rest.ENTIDAD_LIST_BY_ORGANISMO_ORIGEN, enabled)
}

export {
  useFetchColegios,
  useFetchComunidades,
  useFetchEntidades,
  useFetchEntidadesByOrganismoOrigen,
  useFetchMaterias,
  useFetchMunicipios,
  useFetchOrganoJudicial,
  useFetchPais,
  useFetchPartidoJudicial,
  useFetchProcedimientoTipo,
  useFetchProcedimientoTipologia,
  useFetchProvincias,
  useFetchSexo,
  useFetchSubTipoDocumento,
  useFetchTipoDocumento,
  useFetchTipoDocumentoIdentificativo,
  useFetchTipoIntervencion,
  useFetchTipoPersona,
  useFetchTipoRepresentacion,
  useFetchTipoVia
}
